import { render, staticRenderFns } from "./swpNormal.vue?vue&type=template&id=86fb8d7e&scoped=true"
import script from "./swpNormal.vue?vue&type=script&lang=js"
export * from "./swpNormal.vue?vue&type=script&lang=js"
import style0 from "./swpNormal.vue?vue&type=style&index=0&id=86fb8d7e&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fb8d7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86fb8d7e')) {
      api.createRecord('86fb8d7e', component.options)
    } else {
      api.reload('86fb8d7e', component.options)
    }
    module.hot.accept("./swpNormal.vue?vue&type=template&id=86fb8d7e&scoped=true", function () {
      api.rerender('86fb8d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/swpNormal.vue"
export default component.exports